<template>
  <div class="block-wrapper">
    <h2>{{ title }}</h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: "WrapperComponent",
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="stylus">
.block-wrapper {
  display flex
  flex-direction column
  gap 42px

  +below(1024px) {
    gap 24px
  }
}
</style>
